import { ACADEMY_SUPPORTED_LANGUAGES } from 'academy-common-lib/constants/academySupportedLanguages';
export { getLanguagesFromLinkedContent } from 'academy-common-lib/utils/languageUtils';
export const convertToAcademyLanguage = lang => {
  const upperLang = typeof lang === 'string' ? lang.toUpperCase() : 'EN';
  return ACADEMY_SUPPORTED_LANGUAGES.includes(upperLang) ? upperLang : 'EN';
};